import React, { useEffect, useState } from "react";
import Accordion from "../components/Accordion";
import { Link } from "react-router-dom";
import { API } from "../App";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

function Torneos() {
  const [championships, setChampionships] = useState({});
  const getCompetitions = async () => {
    await Promise.allSettled([
      fetchCompetitions("2021"),
      fetchCompetitions("2022"),
      fetchCompetitions("2023"),
      fetchCompetitions("2024"),
    ]).then((results) => {
      setChampionships({
        2021: results[0].value,
        2022: results[1].value,
        2023: results[2].value,
        2024: results[3].value,
      });
    });
  };

  const fetchCompetitions = (year) => {
    try {
      const response = fetch(`${API}/torneos/${year}/campeonatos`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }).then((res) => res.json());
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCompetitions();
  }, []);
  return (
    <>
      <Link to="/" className="torneos__backBtn">
        <ArrowBackIosNewIcon />
      </Link>
      <div className="torneos">
        <div className="torneos__heading">
          <h1 className="torneos__title">Torneos</h1>
        </div>
        <ul className="torneos__years">
          {Object.keys(championships).length > 0 &&
            ["2024","2023", "2022", "2021"].map((year) => (
              <li key={year} className="torneos__year">
                <Accordion
                  title={year}
                  theme="light"
                  content={
                    championships && [
                      championships[year]?.map((championship) => (
                        <Accordion
                          title={championship.internationalName}
                          key={championship.internationalName}
                          accordionKey={championship.internationalName}
                          color="#393C71"
                          theme="dark"
                          content={[
                            <ul className="torneos__competitions">
                              {championship.childs.map((child) => (
                                <Link
                                  to={{
                                    pathname: `/torneos/${child.competitionFifaId}/${championship.internationalName}`,
                                  }}
                                  className="torneos__competition"
                                >
                                  {child.internationalName}
                                </Link>
                              ))}
                            </ul>,
                          ]}
                        />
                      )),
                    ]
                  }
                  accordionKey={year}
                  color="#e8e6ef"
                />
              </li>
            ))}
        </ul>
      </div>
    </>
  );
}

export default Torneos;
